import Swiper from "swiper/bundle";

function setEqualHeight() {
  let slides = document.querySelectorAll('.activity-slider .swiper-slide');
  let maxHeight = 0;

  // Reset heights before calculation
  slides.forEach(slide => {
    slide.style.height = '';
  });

  // Find the max height
  slides.forEach(slide => {
    if (slide.offsetHeight > maxHeight) {
      maxHeight = slide.offsetHeight;
    }
  });

  // Apply the max height to all slides
  slides.forEach(slide => {
    slide.style.height = `${maxHeight}px`;
  });
}

function initSwiper() {
    let screenWidth = window.innerWidth;

    // Initialize Swiper with your desired options
    const swiper = new Swiper(".activity-slider", {
        pagination: false,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        spaceBetween: 30,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        loop: true,
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            640: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 2.5,
            },
            1024: {
                slidesPerView: 3,
            },
        },
    });

    setEqualHeight();
}

initSwiper();

window.addEventListener("resize", initSwiper);
window.addEventListener('resize', setEqualHeight);
